import { trackUserInteraction } from 'actions/tracking';
import { formatPrice } from 'helpers';
import { useDispatch, useHistory, useSelector } from 'hooks';
import { styled, uiAssets } from 'mymoria-ui';
import { Text, Flex } from 'mymoria-ui/components';
import React, { FunctionComponent } from 'react';
import { useRouteMatch } from 'react-router-dom';

interface FavoriteProductsItemProps {
  sku: string;
}

const FavoriteProductsItem: FunctionComponent<FavoriteProductsItemProps> = ({ sku }) => {
  const dispatch = useDispatch();
  const { url } = useRouteMatch();
  const { push } = useHistory();

  const handleClick = (category: string, shortname: string, sku: string) => {
    dispatch(trackUserInteraction('Product Details', shortname));
    push(`${url}/products/${category}/${sku}`);
  };

  const favoriteProduct = useSelector(({ entities }) => entities.products[sku]);

  if (!favoriteProduct) {
    return null;
  }

  const {
    translations: { shortname },
    category,
    pictures,
    placeholder,
    price,
  } = favoriteProduct;

  const image = pictures[0] || placeholder || uiAssets('OfferItem/placeholder.jpg');

  return (
    <Flex
      className="col"
      width={1}
      flexDirection="column"
      display="flex"
      onClick={() => handleClick(category, shortname, sku)}
    >
      <img src={`${image}?width=300&height=200`} alt={shortname} />
      <Text fontWeight="extraBold" fontSize="extraLarge">
        {formatPrice(price)}
      </Text>
      <ProductName>{shortname}</ProductName>
    </Flex>
  );
};

export default FavoriteProductsItem;

const ProductName = styled(Text)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
